import { Badge, Card } from '@warp-ds/react';
import { FavoriteButton } from './FavoriteButton';
import styles from './FeaturedAdsCarousel.module.css';

export type FeaturedAd = {
    itemId: number;
    heading: string;
    imageUrl: string;
    locality: string | null;
    pricePerNight: number | null;
    availableNightsNext60: number;
    noOfBedrooms?: number;
    sleepingCapacity?: number;
};

type FeaturedAdCardProps = {
    ad: FeaturedAd;
    loginId?: string | null;
};

const makeSrcSet = (url: string) => `${url.replace('/default/', '/640x480c/')} 640w, ${url.replace('/default/', '/320x240c/')} 320w`;

const applyImageRule = (url: string, rule: string) => url.replace('/default/', rule);

export const FeaturedAdCard = ({ ad, loginId }: FeaturedAdCardProps) => {
    const adUrl = `/reise/feriehus-hytteutleie/ad.html?finnkode=${ad.itemId}`;

    return (
        <div className={`${styles.card} relative`}>
            <article>
                <Card>
                    <img
                        className="h-144 w-full object-cover"
                        src={applyImageRule(ad.imageUrl, '/480w/')}
                        srcSet={makeSrcSet(ad.imageUrl)}
                        alt={ad.heading}
                        sizes="(min-width: 768px) 280px, 80vw"
                        loading="lazy"
                    />
                    <Badge variant="info" position="top-left" className="px-8 gap-4">
                        Enkel bestilling
                    </Badge>
                    <div className="p-16">
                        {ad.locality && <p className="text-12 text-gray-500 truncate mb-0">{ad.locality}</p>}
                        <h3 className="truncate text-16 font-normal text-gray-800 mt-2">
                            <a
                                href={adUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`${styles.stretchedLink} text-current hover:no-underline focus:no-underline`}>
                                {ad.heading}
                            </a>
                        </h3>
                        {ad.pricePerNight != null && (
                            <p className="text-16 font-bold mt-8 mb-0">Fra {ad.pricePerNight.toLocaleString('nb-NO')} kr / natt</p>
                        )}
                        <p className="text-14 text-gray-500 mt-4 mb-0">
                            {ad.noOfBedrooms != null && <>{ad.noOfBedrooms} soverom</>}
                            {ad.noOfBedrooms != null && ad.sleepingCapacity != null && (
                                <>
                                    {' '}
                                    <span className="text-gray-500" aria-hidden="true">
                                        &bull;
                                    </span>{' '}
                                </>
                            )}
                            {ad.sleepingCapacity != null && <>{ad.sleepingCapacity} sengeplasser</>}
                            {(ad.noOfBedrooms != null || ad.sleepingCapacity != null) && (
                                <>
                                    {' '}
                                    <span className="text-gray-500" aria-hidden="true">
                                        &bull;
                                    </span>{' '}
                                </>
                            )}
                            Privat
                        </p>
                    </div>
                </Card>
            </article>
            <FavoriteButton itemId={ad.itemId} loginId={loginId} wrapperClassName="absolute z-80 top-0 right-0 m-4" />
        </div>
    );
};
